var _path, _path2, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportRoute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0599 6.14258H0.726562V13.6426H14.0599V6.14258H10.7266",
    stroke: "#1E1E1E",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39844 0.725934L7.39844 8.61733L7.39844 10.6895",
    stroke: "#1E1E1E",
    strokeWidth: 0.9
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5103_48939",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 8,
    width: 11,
    height: 4
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.67513,
    height: 9.53084,
    transform: "matrix(-1.19249e-08 1 1 1.19249e-08 2.8125 8.19678)",
    fill: "#808080"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5103_48939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.22656 6.74105L7.39323 10.9077L11.5599 6.74105",
    stroke: "#1E1E1E",
    strokeWidth: 0.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportRoute);
export default __webpack_public_path__ + "static/media/import-route.c9d6cb941f5bee278106412843ef2224.svg";
export { ForwardRef as ReactComponent };